<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-8 col-lg-8">
            <h4>
              <i class="fa fa-building" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
              {{ cvCardTitle }}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="OrgProfileAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="8">
            <b-row>
              <!-- Frontend Search -->
              <!--
              <b-col sm="4" md="4" lg="4" xl="4" class="mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"
                ></b-form-input>
              </b-col>
              -->
              <!-- Frontend Search -->

              <!-- Backend Search -->
               <b-col class="col-12 mb-3">
                <b-form-input class="form-control"
                  @input="searchOrgProfileWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col><!-- Backend Search -->

              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.org_name" class="form-control mb-2" @change="setFilters" title="Choose org name">
                  <option :value="null" disabled>Choose org name</option>
                  <option :value="null">All</option>
                  <option v-for="(item, index) in orgprofileFiltersList['org_name']" :key="index" :value="item.org_name">
                    {{ item.org_name }}
                  </option>
                </select>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="mb-2 col-12 col-lg-4 date_csv">
            <div class="dateRange">
              <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove all filter" @click="removeAllFilter"></i>
              <i v-if="orgprofileObjList && orgprofileObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
              <date-range-picker class="float-right" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange"  @update="getOrgProfileDateWise()" ></date-range-picker>
            </div>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="orgprofileObjList && orgprofileObjList.length > 0" :key="currentBatchNo">
            <b-table
              hover
              responsive
              :items="orgprofileObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
              <template v-slot:cell(action)="data">
                <b-button class="ml-2 actionIcon" @click="OrgProfileEdit(data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 font-size-20"></i></b-button>
                <b-button class="ml-2 actionIcon" @click="showOrgProfileDeleteDialog(data.item)" ><i class="ri-delete-bin-line m-0 font-size-20"></i></b-button>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="7">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="5">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
         </div>
      </b-col>
    </b-row>

    <b-modal size="xxl" v-model="showModelOrgProfileAdd" scrollable :title="cvAddModalHeader">
      <OrgProfileAdd :propOpenedInModal="true" @emitCloseOrgProfileAddModal="closeOrgProfileAddModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeOrgProfileAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelOrgProfileEdit" scrollable :title="cvEditModalHeader" size="xxl">
      <OrgProfileEdit :propOpenedInModal="true" :propOrgProfileObj="orgprofileEditObj" @emitCloseOrgProfileEditModal="closeOrgProfileEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeOrgProfileEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelOrgProfileDelete" size="xxl" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelOrgProfileDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="OrgProfileDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { OrgProfiles } from "../../../../FackApi/api/OrgProfile.js"
import OrgProfileAdd from "./OrgProfileAdd.vue"
import OrgProfileEdit from "./OrgProfileEdit.vue"
import moment from "moment"
import ApiResponse from "../../../../Utils/apiResponse.js"
import { socialvue } from "../../../../config/pluginInit.js"
import userPermission from "../../../../Utils/user_permission.js"

export default {
  name: "OrgProfileList",
  components: {
    OrgProfileAdd,
    OrgProfileEdit
  },
  data () {
    return {
      cvCardTitle: "Organisation Profile Info",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Organisation Profile Info",
      cvAddModalHeader: "Add Organisation Profile Info",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Organisation Profile Info",
      showModelOrgProfileAdd: false,
      showModelOrgProfileEdit: false,
      showModelOrgProfileDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "User Id", key: "user_id", class: "text-left align-text-top", sortable: true },
        { label: "Org Id", key: "org_id", class: "text-left align-text-top", sortable: true },
        { label: "Org Name", key: "org_name", class: "text-left align-text-top", sortable: true },
        { label: "Available Majors", key: "available_majors", class: "text-left align-text-top", sortable: true },
        { label: "Curriculum Design", key: "curriculum_design", class: "text-left align-text-top", sortable: true },
        { label: "Structure Size", key: "structure_size", class: "text-left align-text-top", sortable: true },
        { label: "Selectivity", key: "selectivity", class: "text-left align-text-top", sortable: true },
        { label: "Cost", key: "cost", class: "text-left align-text-top", sortable: true },
        { label: "Weather", key: "weather", class: "text-left align-text-top", sortable: true },
        { label: "Religiosity", key: "religiosity", class: "text-left align-text-top", sortable: true },
        { label: "Club Extracurriculars", key: "club_extracurriculars", class: "text-left align-text-top", sortable: true },
        { label: "Demographics", key: "demographics", class: "text-left align-text-top", sortable: true },
        { label: "Campus Living Situation", key: "campus_living_situation", class: "text-left align-text-top", sortable: true },
        { label: "Social Life Personality", key: "social_life_personality", class: "text-left align-text-top", sortable: true },
        { label: "Average Annual Income", key: "average_annual_income", class: "text-left align-text-top", sortable: true },
        { label: "Average Graduate Debt", key: "average_graduate_debt", class: "text-left align-text-top", sortable: true },
        { label: "Job Opportunities", key: "job_opportunities", class: "text-left align-text-top", sortable: true },
        { label: "Created On", key: "created_on", class: "text-left align-text-top", sortable: true },
        { label: "Action", key: "action", class: "text-left align-text-top", sortable: false }
      ],
      orgprofileObjList: [],
      orgprofileEditObj: null,
      orgprofileFiltersList: [],
      filter: null,
      csvTitle: "OrgProfile",
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {
        dateRange: {
          startDate: new Date(new Date().setDate(new Date().getDate() - 365)), // From Last Year
          endDate: new Date(new Date().setDate(new Date().getDate() + 1))
        },
        orgName: ""
      },
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.getDateFilter()
    await this.OrgProfileFilterList("org_name")
    this.OrgProfileList()
  },
  methods: {
    /**
     * set Filters
     */
    async setFilters () {
      this.OrgProfileList()
    },
    /**
     * Get daterange from LS. If found then use this as default else use the onse set in the data section of the object
     */
    async getDateFilter () {
      let storeDate = await this.dateFilter
      if (storeDate && storeDate.dateRange) {
        this.whereFilter = storeDate
      }
    },
    /**
     * search OrgProfileWithParams
     */
    async searchOrgProfileWithParams () {
      if (this.whereFilter.search_param.length <= 3) {
        return
      }
      this.currentBatchNo = 1
      this.OrgProfileList()
    },
    /**
     * load More Data
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.OrgProfileList(true)
    },
    /**
     * Calling Function as per whereFilter
     */
    async getOrgProfileDateWise () {
      this.OrgProfileList()
      await this.setDateFilter()
    },
    /**
     * Setting Date Range in the LS
     */
    async setDateFilter () {
      let endDate = this.whereFilter.dateRange.endDate
      this.whereFilter.dateRange.endDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      let whereDateFilter = { dateRange: this.whereFilter.dateRange }
      await this.$store.commit("DateFilter/addSelectedDate", whereDateFilter)
    },
    /**
     * backend Csv Download
     */
    async backendCsvDownload () {
      this.OrgProfileList(false, true)
    },
    /**
     * OrgProfile List
     */
    async OrgProfileList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.downloadCsv = downloadCsv

        let OrgProfileListResp = await OrgProfiles.OrgProfileList(this, this.whereFilter)
        if (OrgProfileListResp.resp_status) {
          if (downloadCsv) {
            window.open(OrgProfileListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.orgprofileObjList = [ ...OrgProfileListResp.resp_data.data ]
          }
          else {
            this.orgprofileObjList = [ ...this.orgprofileObjList, ...OrgProfileListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.orgprofileObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.orgprofileObjList.length
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = OrgProfileListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at OrgProfileList() and Exception:", err)
      }
    },
    /**
     * OrgProfileAdd
     */
    OrgProfileAdd (type) {
      try {
        this.showModelOrgProfileAdd = true
      }
      catch (err) {
        console.error("Exception occurred at OrgProfileAdd() and Exception:", err.message)
      }
    },
    /**
     * OrgProfile Edit
     */
    OrgProfileEdit (item) {
      try {
        this.orgprofileEditObj = item
        this.showModelOrgProfileEdit = true
      }
      catch (err) {
        console.error("Exception occurred at OrgProfileEdit() and Exception:", err.message)
      }
    },
    /**
     * showOrgProfile DeleteDialog
     */
    showOrgProfileDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelOrgProfileDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showOrgProfileDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * OrgProfile Delete
     */
    async OrgProfileDelete () {
      try {
        let OrgProfileDelResp = await OrgProfiles.OrgProfileDelete(this, this.delObj.org_id)
        await ApiResponse.responseMessageDisplay(this, OrgProfileDelResp)

        if (OrgProfileDelResp && !OrgProfileDelResp) {
          this.showModelOrgProfileDelete = false
          return false
        }

        let index = this.orgprofileObjList.indexOf(this.delObj)
        this.orgprofileObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelOrgProfileDelete = false
      }
      catch (err) {
        console.error("Exception occurred at OrgProfileDelete() and Exception:", err.message)
      }
    },
    /**
     * closeOrgProfile AddModal
     */
    closeOrgProfileAddModal (OrgProfileAddData) {
      try {
        if (OrgProfileAddData) {
          if (this.orgprofileObjList && this.orgprofileObjList.length >= 1) {
            let OrgProfileObjLength = this.orgprofileObjList.length
            let lastId = this.orgprofileObjList[OrgProfileObjLength - 1]["id"]
            OrgProfileAddData.id = lastId + 1
          }
          else {
            this.orgprofileObjList = []
            OrgProfileAddData.id = 11111
          }

          OrgProfileAddData.created_on = moment()
          this.orgprofileObjList.unshift(OrgProfileAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelOrgProfileAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeOrgProfileAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeOrgProfile EditModal
     */
    closeOrgProfileEditModal () {
      try {
        this.showModelOrgProfileEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeOrgProfileEditModal() and Exception:", err.message)
      }
    },
    /*
     * OrgProfile FilterList
     */
    async OrgProfileFilterList (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let OrgProfileFilterListResp = await OrgProfiles.OrgProfileFilterList(this, filterName)
        if (OrgProfileFilterListResp) {
          this.orgprofileFiltersList[filterName] = OrgProfileFilterListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at Org_Profile_filter_list_resp() and Exception:", err.message)
      }
    },
    /**
     * remove All Filter
     */
    removeAllFilter () {
      this.whereFilter = {
        orgName: "" // value should be null
      }
      this.OrgProfileList(false, false)
    }
  }
}
</script>
